const SHIPPING_RADIO_CLASS = "customer-shipping";
const PROCEED_TO_CHECKOUT_ID = "proceedToCheckout";
const DELIVERY_DATE_CLASS = "customer-delivery-date";
const DELIVERY_DATE_REMOVE_CLASS = "remove-delivery-date";
const MYSHOPIFY_URL_ELE_ID = "myshopify_url";

const DELIVERY_DATE_FORMAT = "YYYY-MM-DD";
const MAX_DELIVERY_DATE_FOR_ICE_PACKAGING = 60;
const MAX_DELIVERY_DATE_WITHOUT_ICE_PACKAGING = 60;
const UTC_TZ_IDENTIFIER = "Etc/GMT";
const INVALID_INDEX = -1;
const INVALID_PRICE = -1;
const SHIPPING_POLL_MAX_THRESHOLD = 2;
const SHIPPING_POLL_TIMEOUT = 500;
// const SHIPPING_METHODS_REQUIRED_DELIVERY_DATE = [
//   "UPS® Ground",
//   "Free Shipping",
//   "Economy  Shipping"
// ];
const SHIPPING_METHODS_REQUIRED_DELIVERY_DATE = ["*"];
const FREE_SHIPPING = {
  "name": "Free Shipping",
  "presentment_name": "Free Shipping",
  "code": "00",
  "price": "0.00",
  "markup": "0.00",
  "source": "custom_shipping",
  "delivery_date": null,
  "delivery_range": null,
  "delivery_days": [],
  "compare_price": null,
  "phone_required": false,
  "currency": "USD",
  "carrier_identifier": null
};

const GIFT_MESSAGE_ALLOWED_CHARACTERS_REGEX =/[^A-Za-z0-9?.,! \n]/g;
const GIFT_MESSAGE_CHARACTER_PLACEHOLDER = "<CHARACTER_PLACEHOLDER>";
const GIFT_MESSAGE_LINE_PLACEHOLDER = "<LINE_PLACEHOLDER>";
const GIFT_MESSAGE_WARNING_MESSAGE = `Only letters, numbers (0-9), ?, !, commas , periods and spaces are allowed with max ${GIFT_MESSAGE_CHARACTER_PLACEHOLDER} characters in max ${GIFT_MESSAGE_LINE_PLACEHOLDER} lines`;
const DEFAULT_GIFT_MESSAGE_CHARACTERS_THRESHOLD = 250;
const DEFAULT_GIFT_MESSAGE_LINES_THRESHOLD = 5;

const proceedToCheckout = document.querySelector(`#${PROCEED_TO_CHECKOUT_ID}`);
const giftMessageEle = document.getElementById("giftMessage");

let giftShipSettings = {};
let giftMessageCharactersThresholdValue = 0;
let giftMessageLinesThresholdValue = 0;
let taxvalue = 0;
let deliveryDatePickerInstance = null;
let clickedOnAlreadySelected = false;


// window.addEventListener("pageshow", (event) => {
//   if (event.persisted) {
//     window.location.href = ADDRESS_LIST_URL;
//   }
// });

document.addEventListener("DOMContentLoaded", function() {
  getFestiveData();
  setGiftMessageWarnings(
    DEFAULT_GIFT_MESSAGE_CHARACTERS_THRESHOLD,
    DEFAULT_GIFT_MESSAGE_LINES_THRESHOLD
  );
  getValidatedGiftMessage(
    message = null,
    messageAllowedLength = DEFAULT_GIFT_MESSAGE_CHARACTERS_THRESHOLD,
    maxAllowedLines = DEFAULT_GIFT_MESSAGE_LINES_THRESHOLD
  );
  showOhnutsLoadingSpinner();
  couponCodeApplyChecking();//frm promocode-shipping-pages.js
  shippingToBeCalculated();//frm promocode-shipping-pages.js

  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (!Object.keys(cartMultiAddressList).length) {
    window.location.href = ADDRESS_LIST_URL;
    return;
  }

  fetchGiftShipSettings(checkPreviouslyChosenAddressAndItems);
});

function charCounter(maxLength) {
  const textarea = document.getElementById("giftMessage");
  const counter = document.getElementById("giftMessageCounter");
  if (!textarea || !counter) return;

  function updateCounter() {
    const currentLength = textarea.value.length;
    counter.textContent = `${currentLength} / ${maxLength}`;
  }

  updateCounter();
}

function fetchGiftShipSettings(callback = null) {
  const myshopifyUrlEle = document.querySelector(`#${MYSHOPIFY_URL_ELE_ID}`);
  if (!myshopifyUrlEle) {
    return callback?.();
  }

  showOhnutsLoadingSpinner();
  fetch(`/a/gs/settings/?myshopify_url=${myshopifyUrlEle.value}&page_type=cart&locale=en`)
  .then((response) => response.json())
  .then((data) => {
    giftShipSettings = data;
    return callback?.();
  })
  .catch((error) => {
    console.error("Error[fetchGiftShipSettings]:", error);
    return callback?.();
  });
}

function getSingleAddressBlockId() {
  let blockId = null;
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (!Object.keys(cartMultiAddressList).length) return blockId;

  for (const key in cartMultiAddressList) {
    if (Object.hasOwn(cartMultiAddressList, key)) {
      blockId = key;
      break;
    }
  }

  return blockId;
}

function getSingleAddressBlockDetails(blockId) {
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (emptyObjectChecking(cartMultiAddressList)) return {};

  return cartMultiAddressList[blockId] || {};
}

function setProceedToCheckoutLoading() {
  addClassesToElements(`#${PROCEED_TO_CHECKOUT_ID}`, ["loading", "read-only"]);
}

function resetProceedToCheckoutLoading() {
  removeClassesFromElements(`#${PROCEED_TO_CHECKOUT_ID}`, ["loading", "read-only"]);
}

function checkPreviouslyChosenAddressAndItems() {
  setProceedToCheckoutLoading();
  showOhnutsLoadingSpinner();
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (!Object.keys(cartMultiAddressList).length) {
    window.location.href = ADDRESS_LIST_URL;
    return;
  }

  let addressId = null;
  let addressDetails = null;
  let oldGiftMessage = "";
  for (const key in cartMultiAddressList) {
    if (Object.hasOwn(cartMultiAddressList, key)) {
      addressId = key;
      addressDetails = cartMultiAddressList[key]?.address || null;
      oldGiftMessage = cartMultiAddressList[key]?.giftMessage || "";
      break;
    }
  }

  if (!addressId || !addressDetails) {
    resetProceedToCheckoutLoading();
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      "Address info not found, please choose first",
      "Address Error",
      "Go to addresses",
      ADDRESS_LIST_URL
    );
  }

  if (isAddressIncomplete(addressDetails)) {
    resetProceedToCheckoutLoading();
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      "You have assigned product(s) to an incomplete address",
      "Address Error",
      "Go to addresses",
      ADDRESS_LIST_URL
    );
  }

  giftMessageEle && (giftMessageEle.value = oldGiftMessage);
  charCounter(DEFAULT_GIFT_MESSAGE_CHARACTERS_THRESHOLD);

  fetch(window.Shopify.routes.root + "cart.js")
  .then((response) => response.json())
  .then((responseJson) => {
    saveAddressAndfetchShippingMethods(addressDetails, responseJson);
  })
  .catch((e) => {
    console.error(e);
    resetProceedToCheckoutLoading();
    return showOhnutsCustomModal(
      "Failed to retrieve cart data",
      "Cart Error",
      "Close",
      CART_REDIRECT_URL
    );
  })
  .finally(() => {
    hideOhnutsLoadingSpinner();
  });
}

function saveAddressAndfetchShippingMethods(chosenAddress, cartJson) {
  if (!Object.keys(chosenAddress).length) {
    resetProceedToCheckoutLoading();
    return showOhnutsCustomModal(
      "Address info not found, please choose first",
      "Address Error",
      "Go to addresses",
      ADDRESS_LIST_URL
    );
  }

  const cartToken = cartJson?.token || null;
  let cartItems = cartJson?.items || null;
  if (!cartToken || !cartItems) {
    resetProceedToCheckoutLoading();
    return showOhnutsCustomModal(
      "Failed to retrieve cart data",
      "Cart Error",
      "Close",
      CART_REDIRECT_URL
    );
  }

  cartItems = getSlimCartItems(cartItems);
  saveOhnutsInfo(SINGLE_CART_TOKEN_KEY, cartToken);
  saveOhnutsInfo(SINGLE_CART_ITEMS_KEY, JSON.stringify(cartItems));
  let oldGiftMessage = "";
  let oldShippingRate = "";
  let oldDeliveryDate = "";
  const oldCartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (Object.keys(oldCartMultiAddressList).length == 1) {
    for (const key in oldCartMultiAddressList) {
      if (Object.hasOwn(oldCartMultiAddressList, key)) {
        oldGiftMessage = oldCartMultiAddressList[key]?.giftMessage || oldGiftMessage;
        oldShippingRate = oldCartMultiAddressList[key]?.shippingRate || oldShippingRate;
        oldDeliveryDate = oldCartMultiAddressList[key]?.deliveryDate || oldDeliveryDate;
      }
    }
  }
  let cartMultiAddressList = {};
  cartMultiAddressList[chosenAddress.id] = {
    blockId: chosenAddress.id,
    address: chosenAddress,
    cartItems: cartItems,
    giftMessage: oldGiftMessage,
    shippingRate: oldShippingRate,
    deliveryDate: oldDeliveryDate
  };

  saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
  renderDeliveryDates(cartMultiAddressList);
  checkAvailableShippingRates(chosenAddress, cartItems, chosenAddress.id);
}

function renderDeliveryDates(cartMultiAddressList) {
  const shopTimezone = giftShipSettings?.shop?.timezone || null;
  const shopTimezoneIdentifier = getZoneFromTimezone(shopTimezone);
  const localTimezoneIdentifier = getBrowserTimezone();
  const datePickerSettings = giftShipSettings?.options?.datepicker || {};
  const leadTime = parseInt(datePickerSettings?.lead_time || 1);

  const minDeliveryDate = generateMinDeliveryDate(
    leadTime,
    shopTimezoneIdentifier,
    localTimezoneIdentifier,
    DELIVERY_DATE_FORMAT
  );

  const {
    disallowedDays,
    disabledDates,
    disabledDatesList
  } = getGiftShipDisabledDates(
    datePickerSettings,
    shopTimezoneIdentifier,
    localTimezoneIdentifier,
    DELIVERY_DATE_FORMAT
  );

  const targetAddressBlocks = [];
  for (const [blockId, blockDetails] of Object.entries(cartMultiAddressList)) {
    const deliveryDate = blockDetails?.deliveryDate || "";
    if (deliveryDate !== "" && isValidDate(deliveryDate, DELIVERY_DATE_FORMAT)) {
      const deliveryDay = new Date(deliveryDate).getDay();
      if (
        (disabledDates.length && disabledDates.indexOf(deliveryDate) != INVALID_INDEX)
        || (disallowedDays.length && disallowedDays.indexOf(deliveryDay) != INVALID_INDEX)
      ) {
        targetAddressBlocks.push(blockId);
      }
    }

    let maxDeliveryDate = "";
    const currentDate = new Date();
    if (cartItemsIcePackage) {
      currentDate.setDate(currentDate.getDate() + MAX_DELIVERY_DATE_FOR_ICE_PACKAGING);
    } else {
      currentDate.setDate(currentDate.getDate() + MAX_DELIVERY_DATE_WITHOUT_ICE_PACKAGING);
    }
    maxDeliveryDate = currentDate.toISOString().split("T")[0];

    const targetDateElement = document.querySelector("#delivery-date-container");
    if (targetDateElement) {
      const datePickerConfig = {
        dateFormat: DELIVERY_DATE_FORMAT,
        minDate: minDeliveryDate,
        maxDate: maxDeliveryDate,
        defaultDate: deliveryDate,
        enableTime: false,
        allowInput: false,
        formatDate: (date, format) => {
          return moment(date).format(format);
        },
        parseDate: (datestr, format) => {
          return moment(datestr, format, true).toDate();
        },
        disable: disabledDatesList,
        wrap: true,
        disableMobile: true
      };

      deliveryDatePickerInstance = flatpickr(targetDateElement, datePickerConfig);
    }
  }

  targetAddressBlocks.length && (
    resetDeliveryDateForAddressBlocks(targetAddressBlocks)
  );
}

function getZoneFromTimezone(shopTimezone) {
  return shopTimezone?.split(" ")?.[1]?.trim() || UTC_TZ_IDENTIFIER;
}

function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function generateMinDeliveryDate(
  leadTime,
  sourceTimezone,
  targetTimezone,
  dateFormat
) {
  const { year, month, day } = getDateComponents(new Date());
  const targetDateStr = convertDateStringTimezoneWise(
    `${year}-${month}-${day}`,
    sourceTimezone,
    targetTimezone,
    dateFormat
  );

  return new Date(targetDateStr).fp_incr(leadTime);
}

function getDateComponents(dateObj) {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return { year, month, day };
}

function convertDateStringTimezoneWise(
  dateStr,
  sourceTimezone,
  targetTimezone,
  dateFormat = DELIVERY_DATE_FORMAT
) {
  const sourceDate = moment.tz(dateStr, sourceTimezone);
  const targetDate = sourceDate.clone().tz(targetTimezone);
  return targetDate.format(dateFormat);
}

function getGiftShipDisabledDates(
  datePickerSettings,
  shopTimezoneIdentifier,
  localTimezoneIdentifier,
  dateFormat
) {
  let disabledDatesList = [];

  let disallowedDays = datePickerSettings?.disallowed_days || [];
  disallowedDays = disallowedDays.map((item) => parseInt(item));
  if (disallowedDays.length) {
    disabledDatesList.push(
      function(date) {
        return disallowedDays.indexOf(date.getDay()) != INVALID_INDEX;
      }
    );
  }

  let disabledDates = datePickerSettings?.disabled_dates || [];
  if (disabledDates.length) {
    disabledDates = disabledDates.map(
      (dateStr) => convertDateStringTimezoneWise(
        dateStr,
        shopTimezoneIdentifier,
        localTimezoneIdentifier,
        dateFormat
      )
    );
    disabledDatesList = disabledDatesList.concat(disabledDates);
  }

  return { disallowedDays, disabledDates, disabledDatesList };
}

function resetDeliveryDateForAddressBlocks(blocksId) {
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (Object.keys(cartMultiAddressList).length) {
    for (const blockId of blocksId) {
      if (cartMultiAddressList[blockId]) {
        cartMultiAddressList[blockId]["deliveryDate"] = "";
      }
    }

    saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
  }
}

function checkAvailableShippingRates(chosenAddress, cartItems, blockId) {
  const buildShippingAddressPayload = (address) => ({
    customer_id: address?.customer_id || "",
    shipping_address: {
      first_name: address?.first_name || "",
      last_name: address?.last_name || "",
      company: address?.company || "",
      address1: address?.address1 || "",
      address2: address?.address2 || "",
      city: address?.city || "",
      province: address?.province || "",
      province_code: address?.province_code || "",
      country: address?.country || "",
      country_code: address?.country_code || "",
      zip: address?.zip || ""
    }
  });

  const buildCartItemsPayload = (items) => {
    return items
      .filter((item) => item?.variant_id && item?.quantity)
      .map((item) => ({
        variant_id: item.variant_id,
        quantity: parseInt(item.quantity)
      }));
  };

  let payload = buildShippingAddressPayload(chosenAddress);
  let cart_items = buildCartItemsPayload(cartItems);

  if (cart_items.length) {
    payload["line_items"] = cart_items;
  }

  const url = `${SHOPIFY_APP_BASE_URL}/check-available-shipping-rates`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };

  showOhnutsLoadingSpinner();
  fetch(url, options)
  .then((response) => response.json())
  .then((response) => {
    if (response?.status === "ok" && response?.data?.shipping_rates?.length) {
      const totalTax = parseFloat(
        response?.data?.payment_info?.totalTaxSet?.shopMoney?.amount ?? 0.00
      );
      if (totalTax) {
        taxvalue = totalTax;
        document.getElementById("estimated_taxes").innerHTML = `$${totalTax}`;
      }
      response.data.shipping_rates.sort(
        (a, b) => parseFloat(a.price.amount) - parseFloat(b.price.amount)
      );
      hideOhnutsLoadingSpinner();
      
      let shippingRates = response.data.shipping_rates || [];

      // 1. Check if Free Shipping exists
      const hasFreeShipping = shippingRates.some(rate =>
        rate?.title === "Free Shipping"
      );

      // 2. If Free Shipping exists, update UPS Ground price and remove Free Shipping
      if (hasFreeShipping) {
        shippingRates = shippingRates
          .filter(rate => rate?.title !== "Free Shipping") // remove Free Shipping
          .map(rate => {
            const { handle, ...rest } = rate; // remove handle safely
            if (rate?.title === "UPS® Ground") {
              return {
                ...rest,
                price: {
                  ...rate.price,
                  amount: "0.00"
                }
              };
            }
            return rest;
          });
      }
      response.data.shipping_rates = shippingRates;
      renderShippingRates(response.data.shipping_rates, blockId);
      fetchAndRenderShippingEstimatedDeliveries(chosenAddress, blockId);
    } else if (response?.status === "error") {
      prepareShippingRatesForDestination(chosenAddress, blockId);
      return showOhnutsCustomModal(
        response.message,
        "Address Error",
        "Go to addresses",
        ADDRESS_LIST_URL
      );
    } else {
      prepareShippingRatesForDestination(chosenAddress, blockId);
    }
  })
  .catch((error) => {
    console.error(error);
    prepareShippingRatesForDestination(chosenAddress, blockId);
  });
}

function renderShippingRates(shippingRates, blockId) {
  let shippingRatesUI = "";
  let previousSelectionFound = false;
  let previouslySelectedPrice = INVALID_PRICE;
  let blockShippingRate = "";
  let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (cartMultiAddressList[blockId]) {
    blockShippingRate = cartMultiAddressList[blockId]["shippingRate"];
    if (blockShippingRate != ""
      && isObject(blockShippingRate)
      && blockShippingRate?.handle
    ) {
      blockShippingRate = blockShippingRate.handle;
    } else {
      blockShippingRate = "";
    }
  }

  fetch("/cart/async_shipping_rates")
  .then((response) => {
    if (response?.status === 200) {
      return response.json();
    }
  }).then((response) => {
    let asyncShippingRates = "";
    if (response?.shipping_rates) {
      asyncShippingRates = response.shipping_rates;
    }

    let asyncindex ="";
    let selectShipping = "";
    let lowestRateIndex = 0;
    let lowestRateAmount = Infinity;

    // First, find the index of the lowest shipping rate
    for (let index = 0; index < shippingRates.length; index++) {
      const amount = parseFloat(shippingRates[index].price.amount);
      if (amount < lowestRateAmount) {
        lowestRateAmount = amount;
        lowestRateIndex = index;
      }
    }

    for (let index = 0; index < shippingRates.length; index++) {
      const shippingRate = shippingRates[index];
      const price = Number(shippingRate.price.amount) === 0 ? "Free" : `$${Number(shippingRate.price.amount).toFixed(2)}`;
      const display = shippingRate.title;
      const handle = shippingRate?.handle || "";
      const selectShipping = index === lowestRateIndex ? "checked" : "";

      if (index === lowestRateIndex) {
        previouslySelectedPrice = parseFloat(shippingRate.price.amount);
        previousSelectionFound = true;
      }

      shippingRatesUI += `<div class="address-card">
        <input id="customer-shipping-${index}"
          name="customer-shipping"
          type="radio"
          class="radio ${SHIPPING_RADIO_CLASS}"
          data-block-id="${blockId}"
          ${selectShipping}
        />
        <script type="application/json" id="customer-shipping-${index}-details">${JSON.stringify(shippingRate)}</script>
        <div class="address-card-part">
          <div class="left-radio">
            <div class="radio-custom">
              <div class="radio-inner-custom"></div>
            </div>
            <div class="radio-txt">
              <h3 class="green-txt">${price} <small>${display}</small></h3>
            </div>
          </div>
          <div class="right-radio expected-delivery-container" data-block-id="${blockId}">
            <div class="expected-delivery-details" data-block-id="${blockId}" data-shipping-rate-title="${display}">&nbsp;</div>
          </div>
        </div>
      </div>`;

      asyncindex = index;
    }

    if (shippingRates.length !== (asyncShippingRates?.length ?? 0)) {
      const unmatched = asyncShippingRates
        ? asyncShippingRates.filter(item1 =>
            !shippingRates.some(item2 => item1.name === item2.title)
          )
        : [];
      const unmatchedItems = unmatched.length > 0 ? unmatched[0] : null;
      const unmatchedItemsPrice = unmatchedItems?.price === "0.00" ? "Free" : `$${Number(unmatchedItems?.price || 0).toFixed(2)}`;
      const unmatchedItemDisplay = unmatchedItems?.name || "Unavailable";
      //start code for appaned Local Delivery
      // if (unmatchedItemDisplay == "Local Delivery") {
      //   shippingRatesUI += `<div class="address-card">
      //     <input id="customer-shipping-${asyncindex+1}"
      //       name="customer-shipping"
      //       type="radio"
      //       class="radio ${SHIPPING_RADIO_CLASS}"
      //       data-block-id="${blockId}"
      //     />
      //     <script type="application/json" id="customer-shipping-${asyncindex+1}-details">${JSON.stringify(unmatchedItems)}</script>
      //     <div class="address-card-part">
      //       <div class="left-radio">
      //         <div class="radio-custom">
      //           <div class="radio-inner-custom"></div>
      //         </div>
      //         <div class="radio-txt">
      //           <h3 class="green-txt">${unmatchedItemsPrice} <small>${unmatchedItemDisplay}</small></h3>
      //         </div>
      //       </div>
      //       <div class="right-radio expected-delivery-container" data-block-id="${blockId}">
      //         <h4 class="expected-delivery-details" data-block-id="${blockId}" data-shipping-rate-title="${unmatchedItemDisplay}">&nbsp;</h4>
      //       </div>
      //     </div>
      //   </div>`;
      // }
      //end code for appaned Local Delivery
    }

    if (!previousSelectionFound) {
      if (cartMultiAddressList[blockId]) {
        cartMultiAddressList[blockId]["shippingRate"] = "";
        saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
      }
    } else if (previouslySelectedPrice !== INVALID_PRICE) {
      updateShippingPriceInOrderSummary(previouslySelectedPrice);
      onloadshipingselecting();
    }

    const shippingMethodsList = document.querySelector("#shippingMethodsList");
    shippingMethodsList && (shippingMethodsList.innerHTML = shippingRatesUI);

    prepareAndRenderDeliveryDateForAllBlocks();
    selectLowestCostShippingMethodForAddresses();
    resetProceedToCheckoutLoading();
  });
}

function prepareAndRenderDeliveryDateForAllBlocks() {
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);

  for (const [blockId, blockDetails] of Object.entries(cartMultiAddressList)) {
    const chosenShippingMethod = blockDetails?.shippingRate || "";
    prepareAndRenderDeliveryDateForBlock(blockId, chosenShippingMethod);
  }
}

function selectLowestCostShippingMethodForAddresses() {
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);

  for (const [blockId, blockDetails] of Object.entries(cartMultiAddressList)) {
    const chosenShippingMethod = blockDetails?.shippingRate || "";
    if (!chosenShippingMethod) {
      const targetShippingMethodId = getLowestCostShippingMethodForBlock(blockId);
      if (targetShippingMethodId) {
        document.querySelector(`#${targetShippingMethodId}`)?.click();
      }
    }
  }
}

function getLowestCostShippingMethodForBlock(blockId) {
  const blockShippingMethods = document.querySelectorAll(`[name="customer-shipping"]`);
  if (!blockShippingMethods.length) return null;

  let selectedElementId = null;
  let selectedShippingPrice = -1;

  blockShippingMethods.forEach((blockShippingMethod) => {
    const targetId = blockShippingMethod?.getAttribute("id") || null;

    if (targetId) {
      let shippingMethodDetails = document.querySelector(`#${targetId}-details`)?.innerHTML?.trim() || null;
      if (shippingMethodDetails) {
        shippingMethodDetails = JSON.parse(shippingMethodDetails);
        const shippingPrice = parseFloat(getShippingMethodPrice(shippingMethodDetails));
        if ((selectedShippingPrice === -1)
          || (shippingPrice < selectedShippingPrice)
        ) {
          selectedShippingPrice = shippingPrice;
          selectedElementId = targetId;
        }
      }
    }
  });

  return selectedElementId;
}

function fetchAndRenderShippingEstimatedDeliveries(chosenAddress, blockId) {
  setBlockEstimatedDeliveryLoading(blockId);
  prepareShippingRatesForDestination(
    chosenAddress,
    blockId,
    renderShippingEstimatedDeliveries
  );
}

function setBlockEstimatedDeliveryLoading(blockId) {
  const deliveryContainers = document.querySelectorAll(
    `.expected-delivery-container[data-block-id="${blockId}"]`
  );

  deliveryContainers.forEach((deliveryContainer) => {
    deliveryContainer.classList.add("loading");
  });
}

function resetBlockEstimatedDeliveryLoading(blockId) {
  const deliveryContainers = document.querySelectorAll(
    `.expected-delivery-container[data-block-id="${blockId}"]`
  );

  deliveryContainers.forEach((deliveryContainer) => {
    deliveryContainer.classList.remove("loading");
  });
}

function renderShippingEstimatedDeliveries(shippingRates, blockId) {
  resetBlockEstimatedDeliveryLoading(blockId);
  const blockDetails = getSingleAddressBlockDetails(blockId);
  const datePickerSettings = giftShipSettings?.options?.datepicker || {};
  const leadTime = parseInt(datePickerSettings?.lead_time || 0);
  // const deliveryMessages = prepareShippingRateWiseDeliveryMessage(shippingRates, leadTime);
  const {
    deliveryMessages,
    deliveryStartDateObjects
  } = prepareShippingRateWiseDeliveryInfo(shippingRates, leadTime, blockDetails);
  const shippingDeliveryDays = prepareShippingRateWiseDeliveryDays(shippingRates);
  const shippingcodesdata = prepareShippingRateWiseCodes(shippingRates);
  const deliveryDetailsContainers = document.querySelectorAll(
    `.expected-delivery-details[data-block-id="${blockId}"]`
  );

  deliveryDetailsContainers.forEach((deliveryDetailsContainer) => {
    const shippingRateTitle = deliveryDetailsContainer.getAttribute(
      "data-shipping-rate-title"
    );

    if (shippingRateTitle && Object.hasOwn(deliveryMessages, shippingRateTitle)) {
      if (deliveryMessages[shippingRateTitle]) {
        deliveryDetailsContainer.innerHTML = `${deliveryMessages[shippingRateTitle]}`;
      }

      if (deliveryStartDateObjects[shippingRateTitle]) {
        const formattedStartDateStr = formattedDateStringForCalendar(
          deliveryStartDateObjects[shippingRateTitle]
          || null
        );
        deliveryDetailsContainer.setAttribute("data-calendar-start-date", formattedStartDateStr);
      }

      if (shippingDeliveryDays[shippingRateTitle]) {
        deliveryDetailsContainer.setAttribute("data-delivery-day", shippingDeliveryDays[shippingRateTitle]);
      }

      if (shippingcodesdata[shippingRateTitle]) {
        deliveryDetailsContainer.setAttribute("data-delivery-code", shippingcodesdata[shippingRateTitle]);
      }
    }
  });

  if (!clickedOnAlreadySelected) {
    clickCheckedShippingRadioByBlockId(blockId);
    clickedOnAlreadySelected = true;
  }
}

function clickCheckedShippingRadioByBlockId(blockId) {
  const checkedRadio = document.querySelector(
    `input.customer-shipping[type="radio"][data-block-id="${blockId}"]:checked`
  );

  if (checkedRadio) {
    checkedRadio.click();
  } else {
    console.error(`No checked radio button found for block ID: ${blockId}`);
  }
}

document.addEventListener("click", function (event) {
	const target = event.target;
	const targetClassList = [...target.classList];

  if (targetClassList.indexOf(SHIPPING_RADIO_CLASS) > INVALID_INDEX) {
    const blockId = target.getAttribute("data-block-id");
    processAddressBlockShippingMethodSelection(blockId);
  } else if (targetClassList.indexOf(DELIVERY_DATE_REMOVE_CLASS) > INVALID_INDEX) {
    const blockId = getSingleAddressBlockId();
    if (blockId) {
      resetDeliveryDateForAddressBlocks([blockId]);
    }
  }
});

function processAddressBlockShippingMethodSelection(blockId) {
  if (!blockId) {
    return showOhnutsCustomModal(
      "Failed to get address block, choose different shipping method for this address!",
      "Shipping Method Error",
      "Close",
    );
  }

  let selectedShippingMethod = document.querySelector(`[name="customer-shipping"]:checked`);
  if (!selectedShippingMethod) {
    return showOhnutsCustomModal(
      "Failed to get chosen shipping method for this address!",
      "Shipping Method Error",
      "Close",
    );
  }

  const shippingMethodId = selectedShippingMethod?.id || "";
  const shippingMethodDetailsEle = document.querySelector(`#${shippingMethodId}-details`);
  if (!shippingMethodDetailsEle?.innerHTML) {
    selectedShippingMethod.checked = false;
    return showOhnutsCustomModal(
      "Shipping method element missing, please choose another one",
      "Shipping Method Error",
      "Close"
    );
  }

  let chosenShippingMethod = {}
  try {
    chosenShippingMethod = JSON.parse(shippingMethodDetailsEle?.innerHTML);
  } catch (error) {
    selectedShippingMethod.checked = false;
    console.error(`Failed during parsing shipping method : `, error);
    return showOhnutsCustomModal(
      "Shipping method parsing error, please choose another one",
      "Shipping Method Error",
      "Close"
    );
  }

  daleverySectionValidation(chosenShippingMethod.title);
  let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (cartMultiAddressList[blockId]) {
    cartMultiAddressList[blockId]["shippingRate"] = chosenShippingMethod;
    saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
    const chosenShippingMethodPrice = getShippingMethodPrice(chosenShippingMethod);
    updateShippingPriceInOrderSummary(parseFloat(chosenShippingMethodPrice));
    prepareAndRenderDeliveryDateForBlock(blockId, chosenShippingMethod);
  }
}

function prepareAndRenderDeliveryDateForBlock(blockId, chosenShippingMethod) {
  const deliveryDateInputGroupSelector = "#delivery-date-container";
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  const shippingMethods = SHIPPING_METHODS_REQUIRED_DELIVERY_DATE;
  if (isEmptyArray(shippingMethods) || !cartMultiAddressList[blockId]) {
    return addClassesToElements(deliveryDateInputGroupSelector, ["read-only"]);
  }

  const shippingTitle = getShippingMethodTitle(chosenShippingMethod);
  if (shippingMethods.length === 1 && shippingMethods[0] === "*") {
    const calendarStartDate = getCalendarStartDateByBlockIdAndShippingTitle(blockId, shippingTitle);
    if (calendarStartDate && deliveryDatePickerInstance) {
      updateFlatpickrCalendarMinDate(deliveryDatePickerInstance, calendarStartDate);
    }
    return removeClassesFromElements(deliveryDateInputGroupSelector, ["read-only"]);
  }

  const isRequired = shippingMethods.includes(shippingTitle);
  if (isRequired) {
    const calendarStartDate = getCalendarStartDateByBlockIdAndShippingTitle(blockId, shippingTitle);
    if (calendarStartDate && deliveryDatePickerInstance) {
      updateFlatpickrCalendarMinDate(deliveryDatePickerInstance, calendarStartDate);
    }
    removeClassesFromElements(deliveryDateInputGroupSelector, ["read-only"]);
  } else {
    addClassesToElements(deliveryDateInputGroupSelector, ["read-only"]);
    resetDeliveryDateForBlock(blockId);
  }
}

function getCalendarStartDateByBlockIdAndShippingTitle(blockId, shippingTitle) {
  const element = document.querySelector(
    `.expected-delivery-details[data-block-id="${blockId}"][data-shipping-rate-title="${shippingTitle}"]`
  );
  return element?.getAttribute("data-calendar-start-date") || null;
}

function getShippingMethodTitle(method = {}) {
  const DEFAULT_TITLE = "";
  if (emptyObjectChecking(method)) return DEFAULT_TITLE;

  return (
    method?.title
    || method?.name
    || method?.presentment_name
    || method?.code
    || DEFAULT_TITLE
  );
}

function getShippingMethodPrice(method = {}) {
  const DEFAULT_PRICE = "0.00";
  const freeShippingchecking = isShippingCouponApplied();
  if (!freeShippingchecking) {
    if (emptyObjectChecking(method)) return DEFAULT_PRICE;

    return (
      method?.price?.amount
      || method?.price
      || DEFAULT_PRICE
    );
  } else {
    return DEFAULT_PRICE;
  }
}

function isShippingCouponApplied() {
  const freeShipping = localStorage.getItem("freeShipping");
  const storedCode = localStorage.getItem("couponCode");

  if (freeShipping == "free" && storedCode) {
    const totalshiipingprice = document.querySelector("#main-cart-footer__shipping").innerHTML.replace("$", "");
    const totalPrice = document.querySelector("#main-cart-footer__total").innerHTML.replace("$", "");
    let finaltotal = totalPrice;
    if (!isNaN(totalshiipingprice)) {
      finaltotal = parseFloat(finaltotal) - parseFloat(totalshiipingprice);
    }
    document.querySelector("#main-cart-footer__shipping").innerHTML = "Free";
    document.querySelector("#main-cart-footer__total").innerHTML = renderMoney(finaltotal);
    return 1;
  } else {
    return;
  }
}

function resetDeliveryDateForBlock(blockId) {
  resetDeliveryDateForAddressBlocks([blockId]);
  const deliveryDateInput = document.querySelector(`#delivery-date`);
  if (deliveryDateInput) deliveryDateInput.value = "";
}

document.addEventListener("change", function(event){
  const target = event.target;
	const targetClassList = [...target.classList];

  if (targetClassList.indexOf(DELIVERY_DATE_CLASS) > INVALID_INDEX) {
    const targetBlockId = getSingleAddressBlockId();
    const changedDate = target.value.trim();
    const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);

    if (
      targetBlockId
      && isValidDate(changedDate, DELIVERY_DATE_FORMAT)
      && cartMultiAddressList[targetBlockId]
    ) {
      cartMultiAddressList[targetBlockId]["deliveryDate"] = changedDate;
      saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
    }
  }
});

function isValidDate(dateString, format) {
  return moment(dateString, format, true).isValid();
}

function prepareShippingRatesForDestination(
  chosenAddress,
  blockId,
  callback = null,
  maxRetries = SHIPPING_POLL_MAX_THRESHOLD
) {
  let retries = 0;
  const province = chosenAddress?.province || "";
  const country = chosenAddress?.country || "";
  const zip = chosenAddress?.zip || "";

  const formData = new FormData();
  if (province) formData.append("shipping_address[province]", province);
  if (country) formData.append("shipping_address[country]", country);
  if (zip) formData.append("shipping_address[zip]", zip);

  let errorMessage = "Selected address has following issue(s),";
  errorMessage += " please try with another!";
  errorMessage += "<br/><br/>";

  fetch("/cart/prepare_shipping_rates", {
    method: "POST",
    body: formData
  })
  //.then((response) => response.json())
  .then((response) => {
    if (response) {
      errorMessage += getErrorStringForPrepareShippingRates(response);
      return showOhnutsCustomModal(
        errorMessage,
        "Address Error",
        "Go to addresses",
        ADDRESS_LIST_URL
      );
    } else if (callback) {
      if (retries < maxRetries) {
        retries++;
        pollShippingRatesForDestination(blockId, callback)();
      } else {
        errorMessage += getErrorStringForPrepareShippingRates(response);
        return showOhnutsCustomModal(
          errorMessage,
          "Address Error",
          "Go to addresses",
          ADDRESS_LIST_URL
        );
      }
    }
  })
  .catch((error) => {
    return showOhnutsCustomModal(
      "Failed to get shipping methods for this address, please try with another!",
      "Address Error",
      "Go to addresses",
      ADDRESS_LIST_URL
    );
  });
}

function getErrorStringForPrepareShippingRates(errorResponse) {
  let errorString = "";

  if (Object.keys(errorResponse).length) {
    for (const [field, messages] of Object.entries(errorResponse)) {
      if (typeof messages === "string") {
        errorString += `${field}: ${messages}`;
      } else if (Array.isArray(messages)) {
        const messagesString = messages.map(
          (message) => JSON.stringify(message)
        ).join(", ");
        errorString += `${field}: ${messagesString}`;
      } else if (messages !== null && typeof messages === "object") {
        errorString += `${field}: ${JSON.stringify(messages)}`;
      } else {
        errorString += `${field}`;
      }
    }
  }

  return errorString;
}

function pollShippingRatesForDestination(
  blockId,
  callback = null,
  maxRetries = SHIPPING_POLL_MAX_THRESHOLD
) {
  let retries = 0;

  const pollShippingRates = () => {
    fetch("/cart/async_shipping_rates")
    .then((response) => {
      if (response?.status === 200) {
        return response.json();
      } else {
        setTimeout(pollShippingRates, SHIPPING_POLL_TIMEOUT);
      }
    })
    .then((response) => {
      if (
        response?.shipping_rates
        && Array.isArray(response.shipping_rates)
        && response.shipping_rates.length
      ) {
        response.shipping_rates.push(FREE_SHIPPING);

        if (callback) {
          callback(response.shipping_rates, blockId);
        } else {
          renderShippingRatesAfterPolling(
            response.shipping_rates,
            blockId
          );

          renderShippingEstimatedDeliveries(
            response.shipping_rates,
            blockId
          );
        }
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(pollShippingRates, SHIPPING_POLL_TIMEOUT);
      } else {
        resetProceedToCheckoutLoading();
        hideOhnutsLoadingSpinner();

        if (callback && blockId) return resetBlockEstimatedDeliveryLoading(blockId);

        return showOhnutsCustomModal(
          "Please reload page or try with another address",
          "Address Error",
          "Go to addresses",
          ADDRESS_LIST_URL
        );
      }
    })
    .catch(error => {
      console.error(error);
      resetProceedToCheckoutLoading();
      hideOhnutsLoadingSpinner();

      if (callback && blockId) return resetBlockEstimatedDeliveryLoading(blockId);

      return showOhnutsCustomModal(
        "Failed to get shipping methods for this address, please try with another!",
        "Address Error",
        "Go to addresses",
        ADDRESS_LIST_URL
      );
    });
  }

  return pollShippingRates;
}

function renderShippingRatesAfterPolling(
  shippingRates,
  blockId
) {
  function getBlockCurrentShippingRate(blockId, cartMultiAddressList) {
    if (cartMultiAddressList[blockId]) {
      const blockShippingRate = cartMultiAddressList[blockId]["shippingRate"];

      if (blockShippingRate != "" && isObject(blockShippingRate)) {
        if (blockShippingRate?.handle) {
          return blockShippingRate.handle;
        } else if (blockShippingRate?.code) {
          return blockShippingRate.code;
        }
      }

      return "";
    }

    return "";
  }

  function getShippingRateDisplayInfo(shippingRate, blockShippingRate) {
    let price = "", priceOriginal = INVALID_PRICE;
    if (shippingRate?.price?.amount) {
      price = shippingRate.price.amount == "0.0" ? "Free" : `$${Number(shippingRate.price.amount).toFixed(2)}`;
      priceOriginal = parseFloat(shippingRate.price.amount);
    } else if (shippingRate?.price) {
      price = shippingRate.price == "0.00" ? "Free" : `$${Number(shippingRate.price).toFixed(2)}`;
      priceOriginal = parseFloat(shippingRate.price);
    }

    const display = shippingRate?.title || shippingRate?.name || "";
    const handle = shippingRate?.handle || shippingRate?.code || "";
    let selectShipping = "";
    let previouslySelected = false;
    if (handle == blockShippingRate) {
      selectShipping = "checked";
      previouslySelected = true;
    }

    return { price, display, selectShipping, previouslySelected, priceOriginal };
  }

  function createShippingRateBlockUI(
    blockId,
    index,
    shippingRate,
    blockShippingRate
  ) {
    const displayInfo = getShippingRateDisplayInfo(
      shippingRate,
      blockShippingRate
    );

    const shippingRateBlockUI = `<div class="address-card">
      <input id="customer-shipping-${index}"
        name="customer-shipping"
        type="radio"
        class="radio ${SHIPPING_RADIO_CLASS}"
        data-block-id="${blockId}"
        ${displayInfo.selectShipping}
      />
      <script type="application/json" id="customer-shipping-${index}-details">${JSON.stringify(shippingRate)}</script>
      <div class="address-card-part">
        <div class="left-radio">
          <div class="radio-custom">
            <div class="radio-inner-custom"></div>
          </div>
          <div class="radio-txt">
            <h3 class="green-txt">${displayInfo.price} <small>${displayInfo.display}</small></h3>
          </div>
        </div>
        <div class="right-radio expected-delivery-container" data-block-id="${blockId}">
          <h4 class="expected-delivery-details" data-block-id="${blockId}" data-shipping-rate-title="${displayInfo.display}">&nbsp;</h4>
        </div>
      </div>
    </div>`;

    const previouslySelected = displayInfo.previouslySelected;
    const shippingRateBlockPrice = displayInfo.priceOriginal;
    return { shippingRateBlockUI, previouslySelected, shippingRateBlockPrice };
  }

  let shippingRatesUI = "";
  let previousSelectionFound = false;
  let previouslySelectedPrice = INVALID_PRICE;
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  let blockShippingRate = getBlockCurrentShippingRate(blockId, cartMultiAddressList);

  for (let index = 0; index < shippingRates.length; index++) {
    const {
      shippingRateBlockUI,
      previouslySelected,
      shippingRateBlockPrice
    } = createShippingRateBlockUI(
      blockId,
      index,
      shippingRates[index],
      blockShippingRate
    );

    if (previouslySelected) {
      previousSelectionFound = previouslySelected;
      previouslySelectedPrice = shippingRateBlockPrice;
    }

    shippingRatesUI += shippingRateBlockUI;
  }

  if (!previousSelectionFound) {
    if (cartMultiAddressList[blockId]) {
      cartMultiAddressList[blockId]["shippingRate"] = "";
      saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
    }
  } else if (previouslySelectedPrice !== INVALID_PRICE) {
    updateShippingPriceInOrderSummary(previouslySelectedPrice);
    onloadshipingselecting();
  }

  const shippingMethodsList = document.querySelector("#shippingMethodsList");
  shippingMethodsList && (shippingMethodsList.innerHTML = shippingRatesUI);

  prepareAndRenderDeliveryDateForAllBlocks();
  selectLowestCostShippingMethodForAddresses();
  resetProceedToCheckoutLoading();
  hideOhnutsLoadingSpinner();
}

function updateShippingPriceInOrderSummary(shippingPrice = INVALID_PRICE) {
  let estimatedTaxes = taxvalue;
  const SHIPPING_PRICE_DEFAULT_COLOR = "#97bf42";
  const SELECTED_SHIPPING_PRICE_COLOR = "#525252";
  const DEFAULT_SHIPPING_PRICE_MSG = "To be calculated";

  const footerTotalSpan = document.querySelector("#main-cart-footer__total");
  const footerShippingSpan = document.querySelector("#main-cart-footer__shipping");

  if (!footerTotalSpan || !footerShippingSpan) return;

  let totalPrice = footerShippingSpan.getAttribute("data-total-price") || INVALID_PRICE;
  if (typeof totalPrice === "string") {
    totalPrice = totalPrice.replaceAll(",", "");
  }
  if (estimatedTaxes) {
    totalPrice = addMoney(
      parseFloat(Number(totalPrice).toFixed(2)),
      parseFloat(Number(estimatedTaxes).toFixed(2))
    );
  }

  if (
    parseFloat(shippingPrice) <= INVALID_PRICE
    || parseFloat(totalPrice) <= INVALID_PRICE
  ) {
    footerShippingSpan.innerHTML = DEFAULT_SHIPPING_PRICE_MSG;
    footerShippingSpan.style.color = SHIPPING_PRICE_DEFAULT_COLOR;
    return;
  }

  footerShippingSpan.setAttribute(
    "data-selected-shipping-price",
    parseFloat(shippingPrice)
  );

  footerShippingSpan.innerHTML = `$${Number(shippingPrice).toFixed(2)}`;
  footerShippingSpan.style.color = SELECTED_SHIPPING_PRICE_COLOR;
  const updatedTotalPrice = addMoney(
    parseFloat(totalPrice),
    parseFloat(shippingPrice)
  );
  footerTotalSpan.innerHTML = `$${Number(updatedTotalPrice).toFixed(2)}`;
}

if (giftMessageEle) {
  const debouncedUpdateGiftMessage = debounce(
    updateGiftMessageInCartMultiAddressInfo,
    300
  );
  giftMessageEle.addEventListener("input", (e) => {
    debouncedUpdateGiftMessage();
  });
  giftMessageEle.addEventListener("change", (e) => {
    debouncedUpdateGiftMessage();
  });
}

function updateGiftMessageInCartMultiAddressInfo() {
  if (giftMessageEle) {
    let message = getValidatedGiftMessage(
      giftMessageEle.value,
      giftMessageCharactersThresholdValue,
      giftMessageLinesThresholdValue
    );
    giftMessageEle.value = message;
    let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
    if (Object.keys(cartMultiAddressList).length == 1) {
      for (const key in cartMultiAddressList) {
        cartMultiAddressList[key]["giftMessage"] = message;
      }
      saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
    }
  }
}

function getValidatedGiftMessage(
  message = null,
  messageAllowedLength = DEFAULT_GIFT_MESSAGE_CHARACTERS_THRESHOLD,
  maxAllowedLines = DEFAULT_GIFT_MESSAGE_LINES_THRESHOLD
) {
  const textarea = document.getElementById("giftMessage");
  const counter = document.getElementById("giftMessageCounter");

  if (!isString(message)) return "";

  message = message.replace(/\r\n/g, '\n');

  message = message.replace(GIFT_MESSAGE_ALLOWED_CHARACTERS_REGEX, "");

  message = message.replace(/\n{3,}/g, '\n\n');

  // enforce max lines
  const lines = message.split('\n').slice(0, maxAllowedLines);
  message = lines.join('\n');

  // enforce max non-newline chars
  let charCount = 0;
  let finalValue = "";
  for (const ch of message) {
    if (ch === '\n') {
      finalValue += ch; // always allow line-breaks (up to max lines)
    } else if (charCount < messageAllowedLength) {
      finalValue += ch;
      charCount++;
    } else {
      break; // drop any further non-newline chars
    }
  }

  textarea.addEventListener("input", () => {
    const currentLength = textarea.value.length;
    counter.textContent = `${currentLength} / ${messageAllowedLength}`;
  });

  return finalValue;
}

function isString(value) {
  return typeof value === "string" || value instanceof String;
}

function setGiftMessageWarnings(
  characterPlaceholderValue = DEFAULT_GIFT_MESSAGE_CHARACTERS_THRESHOLD,
  linePlaceHolderValue = DEFAULT_GIFT_MESSAGE_LINES_THRESHOLD
) {
  const giftWarningMessage = `${GIFT_MESSAGE_WARNING_MESSAGE}`
    .replace(GIFT_MESSAGE_CHARACTER_PLACEHOLDER, characterPlaceholderValue)
    .replace(GIFT_MESSAGE_LINE_PLACEHOLDER, linePlaceHolderValue);
  //document.querySelector("#giftMessage").setAttribute("placeholder",giftWarningMessage);
  document.querySelector("#shipping-heading-gift-message").innerHTML = giftWarningMessage;
}

function setDeliveryDatesForAddreses() {
  const shopTimezone = giftShipSettings?.shop?.timezone || null;
  const shopTimezoneIdentifier = getZoneFromTimezone(shopTimezone);
  const localTimezoneIdentifier = getBrowserTimezone();
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);

  if (Object.keys(cartMultiAddressList).length) {
    for (const targetBlockId of Object.keys(cartMultiAddressList)) {
      let updatedDeliveryDate = "";
      const targetDeiveryDate = document.querySelector(`#delivery-date`);
      updatedDeliveryDate = targetDeiveryDate.value.trim();
      // targetDeiveryDate && isValidDate(
      //   targetDeiveryDate.value.trim(),
      //   DELIVERY_DATE_FORMAT
      // ) && (
      //   updatedDeliveryDate = convertDateStringTimezoneWise(
      //     targetDeiveryDate.value.trim(),
      //     localTimezoneIdentifier,
      //     shopTimezoneIdentifier,
      //     DELIVERY_DATE_FORMAT
      //   )
      // );
      cartMultiAddressList[targetBlockId]["deliveryDate"] = updatedDeliveryDate;
    }

    saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
  }
}

if (proceedToCheckout) {
  proceedToCheckout.addEventListener("click", (e) => {
    setProceedToCheckoutLoading();
    showOhnutsLoadingSpinner();

    handleCartItemStockAvailable()
    .then(async (responsestock) => {
      if (responsestock.status == false) {
        showOhnutsLrgCustomModal(
          responsestock.msg,
          "Product Out of Stock",
          "Confirm",
          "",
          () => {
            setTimeout(() => location.reload(), 300);
          },
          false
        )
      } else {
        proceedToCheckoutprocess();
      }
    });
  });
}

function proceedToCheckoutprocess() {
  try {
    const selectedShippingMethod = document.querySelector(
      '[name="customer-shipping"]:checked'
    );
    if (!selectedShippingMethod) {
      throw new Error(
        "Please select a shipping method first"
      );
    }

    const shippingMethodId = selectedShippingMethod?.id || "";
    const shippingMethodDetailsEle = document.querySelector(
      `#${shippingMethodId}-details`
    );
    if (!shippingMethodDetailsEle?.innerHTML) {
      selectedShippingMethod.checked = false;
      throw new Error(
        "Shipping method element missing, please choose another one"
      );
    }

    let chosenShippingMethod = {};
    try {
      chosenShippingMethod = JSON.parse(shippingMethodDetailsEle?.innerHTML);
    } catch (error) {
      selectedShippingMethod.checked = false;
      console.error(`Failed during parsing shipping method. Error: `, error);
      throw new Error(
        "Shipping method parsing error, please choose another one"
      );
    }

    let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
    if (!Object.keys(cartMultiAddressList).length) {
      throw new Error("You did not select any address, please choose first", {
        cause: "Address Error"
      });
    }

    setDeliveryDatesForAddreses();
    cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
    let addressId = null;
    let addressDetails = null;
    for (const key in cartMultiAddressList) {
      addressId = key;
      addressDetails = cartMultiAddressList[key]?.address || null;
      break;
    }

    if (!addressId || !addressDetails) {
      throw new Error("Address info not found, please choose first", {
        cause: "Address Error"
      });
    }

    let giftMessage = "";
    giftMessageEle && (
      giftMessage = getValidatedGiftMessage(
        giftMessageEle.value.trim(),
        giftMessageCharactersThresholdValue || DEFAULT_GIFT_MESSAGE_CHARACTERS_THRESHOLD,
        giftMessageLinesThresholdValue || DEFAULT_GIFT_MESSAGE_LINES_THRESHOLD
      )
    );
    cartMultiAddressList[addressId]["shippingRate"] = chosenShippingMethod;
    cartMultiAddressList[addressId]["giftMessage"] = giftMessage;
    saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
  } catch (error) {
    const message = (
      error.message
      || "Failed to get shipping methods info for this address!"
    );
    const cause = error.cause;

    resetProceedToCheckoutLoading();
    hideOhnutsLoadingSpinner();

    if (cause === "Address Error") {
      return showOhnutsCustomModal(
        message,
        "Address Error",
        "Go to addresses",
        ADDRESS_LIST_URL
      );
    }

    return showOhnutsCustomModal(
      message,
      "Shipping Method Error",
      "Close"
    );
  }

  confirmSingleShippingCheckout();
}

function confirmSingleShippingCheckout() {
  function validateCartMultiAddressList(cartMultiAddressList) {
    if (!Object.keys(cartMultiAddressList).length) {
      resetProceedToCheckoutLoading();
      hideOhnutsLoadingSpinner();
      showOhnutsCustomModal(
        "You did not select any address, please choose first",
        "Address Error",
        "Go to addresses",
        ADDRESS_LIST_URL
      );
      return false;
    }

    return true;
  }

  function createOrderConfirmData(cartMultiAddressList) {
    let customer_id = null;
    let shipping_address = null;
    let line_items = null;
    let shipping_line = null;
    let note = "";
    let delivery_date = "";
    let festive_id = "";
    let shipping_code = "";
    let shipping_delivery_days = [];
    let delivery_required = false;
    let invalid_delivery_date_block = false;
    let discount_code = null;

    for (const key in cartMultiAddressList) {
      if (Object.hasOwn(cartMultiAddressList, key)) {
        const cartAddressInfo = cartMultiAddressList[key];
        shipping_address = cartAddressInfo?.address || null;
        customer_id = shipping_address?.customer_id || null;
        line_items = cartAddressInfo?.cartItems || null;
        shipping_line = cartAddressInfo?.shippingRate || null;
        delivery_required = isDeliveryDateRequired(shipping_line);
        note = cartAddressInfo?.giftMessage || "";
        delivery_date = cartAddressInfo?.deliveryDate || "";
        festive_id = cartAddressInfo?.fetive_id || "";
        shipping_code  = cartAddressInfo?.shipping_code || "";
        shipping_delivery_days  = cartAddressInfo?.shipping_delivery_days || [];
        break;
      }
    }

    if (
      !shipping_address
      || !line_items
      || !shipping_line
    ) {
      resetProceedToCheckoutLoading();
      hideOhnutsLoadingSpinner();
      showOhnutsCustomModal(
        "Some informations are missing, please try again",
        "Confirmation Error",
        "Go to cart",
        CART_REDIRECT_URL
      );
      return null;
    }

    if (invalid_delivery_date_block) {
      resetProceedToCheckoutLoading();
      hideOhnutsLoadingSpinner();
      showOhnutsCustomModal(
        "Please choose delivery date",
        "Delivery Date Error",
        "Close"
      );
      return null;
    }

    const shippingCode = getshippingcode(shipping_line);
    if (shippingCode) {
      shipping_code = shippingCode;
    }
    const shippingDeliveryDays = getshippingDeliveryDays(shipping_line);
    if (shippingDeliveryDays) {
      shipping_delivery_days = JSON.stringify(shippingDeliveryDays);
    }
    shipping_line = prepareShippingLine(shipping_line);
    let promocode = checkingDiscountNode();
    const festiveId = checkingFestiveNode();
    if (festiveId) {
      festive_id = festiveId;
    }
    if (promocode) {
      discount_code = [promocode];
    }

    return {
      customer_id,
      shipping_address,
      line_items,
      shipping_line,
      note,
      delivery_date,
      festive_id,
      shipping_delivery_days,
      shipping_code,
      discount_code
    };
  }

  function prepareShippingLine(shippingLine) {
    if (shippingLine?.handle) {
      return {
        handle: shippingLine.handle,
      };
    }

    const shippingTitle = getShippingMethodTitle(shippingLine) || "Shipping";
    const shippingPrice = parseFloat(getShippingMethodPrice(shippingLine));
    return {
      title: shippingTitle,
      price: shippingPrice,
    };
  }

  function getshippingcode(shippingLine) {
    const shippingTitle = getShippingMethodTitle(shippingLine) || "Shipping";
    let deliverycode = "";
    const deliveryDetailsContainer = document.querySelector(
      `.expected-delivery-details[data-shipping-rate-title="${shippingTitle}"]`
    );
    if (deliveryDetailsContainer) {
      deliverycode = deliveryDetailsContainer.getAttribute("data-delivery-code");
    }

    return deliverycode;
  }

  function getshippingDeliveryDays(shippingLine) {
    const shippingTitle = getShippingMethodTitle(shippingLine) || "Shipping";
    const deliveryDaysArray = [];
    const deliveryDetailsContainer = document.querySelector(
      `.expected-delivery-details[data-shipping-rate-title="${shippingTitle}"]`
    );
    if (deliveryDetailsContainer) {
      const deliveryDays = deliveryDetailsContainer.getAttribute("data-delivery-day");
      if (deliveryDays) {
        deliveryDaysArray.push(...deliveryDays.split(",").map(Number));
      }
    }

    return deliveryDaysArray;
  }

  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (!validateCartMultiAddressList(cartMultiAddressList)) {
    return;
  }

  const orderConfirmData = createOrderConfirmData(cartMultiAddressList);
  submitOrderConfirmData(orderConfirmData);
}

function submitOrderConfirmData(orderConfirmData) {
  if (!orderConfirmData) return;

  const isdraftorderDataAvailable = getSingleDraftOrderFromLocalStorage();
  if (!isdraftorderDataAvailable) {
    const url = `${SHOPIFY_APP_BASE_URL}/create-draft-order`;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(orderConfirmData)
    };

    fetch(url, options)
    .then((response) => response.json())
    .then(handleOrderConfirmationResponse)
    .catch(handleOrderConfirmationError);
  } else {
    const redirectLink = isdraftorderDataAvailable["link"];
    if (redirectLink) {
      resetProceedToCheckoutLoading();
      checkInvoiceUrlAndRedirecttoCheckout(redirectLink)();
    } else {
      resetProceedToCheckoutLoading();
      hideOhnutsLoadingSpinner();
    }
  }
}

function handleOrderConfirmationResponse(result) {
  if (result?.status === "ok") {
    const cartData = [];
    saveCartToCustomerMetafield(cartData);
    // removeOhnutsInfo(SINGLE_CART_TOKEN_KEY);
    // removeOhnutsInfo(SINGLE_CART_ITEMS_KEY);
    // removeOhnutsInfo(SINGLE_ADDRESS_KEY);
    // removeOhnutsDiscountInfo();
    saveDraftOrderInfo(result?.data);

    const redirectLink = result?.data?.link || null;
    if (redirectLink) {
      resetProceedToCheckoutLoading();
      checkInvoiceUrlAndRedirecttoCheckout(redirectLink)();
    } else {
      resetProceedToCheckoutLoading();
      hideOhnutsLoadingSpinner();
    }
  } else {
    const errorMessage = result?.message || "Failed to confirm order, please try again!";
    resetProceedToCheckoutLoading();
    hideOhnutsLoadingSpinner();
    showOhnutsCustomModal(
      errorMessage,
      "Confirmation Error"
    );
  }
}

function saveDraftOrderInfo(draftOrderInfo = {}) {
  if (!emptyObjectChecking(draftOrderInfo)) {
    const { link, draft_order_id, draft_order_type } = draftOrderInfo;
    if (link && draft_order_id && draft_order_type) {
      localStorage.setItem(
        `ohnuts_${draft_order_type}_draft_order_info`,
        JSON.stringify({ draft_order_id, link })
      );
    }
  }
}

function getSingleDraftOrderFromLocalStorage() {
  const data = localStorage.getItem("ohnuts_single_draft_order_info");
  if (data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error("Failed to parse ms draft order from localStorage", e);
    }
  }

  return null;
}

function handleOrderConfirmationError(error) {
  console.error(error);
  resetProceedToCheckoutLoading();
  hideOhnutsLoadingSpinner();
  showOhnutsCustomModal(
    "Failed to confirm order, please try again!",
    "Confirmation Error"
  );
}

function isDeliveryDateRequired(shippingRate) {
  if (!shippingRate) return false;

  const shippingMethodsRequiredDelivery = SHIPPING_METHODS_REQUIRED_DELIVERY_DATE;
  if (isEmptyArray(shippingMethodsRequiredDelivery)) {
    return false;
  }

  if (
    shippingMethodsRequiredDelivery.length === 1
    && shippingMethodsRequiredDelivery[0] === "*"
  ) {
    return true;
  }

  const shippingTitle = getShippingMethodTitle(shippingRate);
  return shippingMethodsRequiredDelivery.includes(shippingTitle);
}

function onloadshipingselecting() {
  let selectedShippingMethod = document.querySelector(`[name="customer-shipping"]:checked`);
  const shippingMethodId = selectedShippingMethod?.id || "";
  const shippingMethodDetailsEle = document.querySelector(`#${shippingMethodId}-details`);
  let chosenShippingMethod = "";

  if (shippingMethodDetailsEle) {
    chosenShippingMethod = JSON.parse(shippingMethodDetailsEle?.innerHTML);
    const chosenShippingMethodPrice = getShippingMethodPrice(chosenShippingMethod);
    updateShippingPriceInOrderSummary(chosenShippingMethodPrice);
  }
}

function isShippingMethodRequired(chosenShippingMethod) {
  return SHIPPING_METHODS_REQUIRED_DELIVERY_DATE.includes(chosenShippingMethod.title);
}

function checkingDiscountNode() {
  const storedCode = localStorage.getItem("couponCode");
  if (storedCode) {
    return storedCode;
  }

  return null;
}

function checkingFestiveNode() {
  const festiveRadio = document.querySelector(".festive");
  if (festiveRadio && festiveRadio.checked) {
    return festiveRadio.value;
  }

  return null;
}

async function checkCartDataAfterApplyPromoCode() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();

    if (cart.total_discount) {
      const itemsData = cart.items;
      const _gs_discount_application = {};

      for (const cart_item of itemsData) {
        const discount_allocation = cart_item?.line_level_discount_allocations?.[0]?.discount_application;
        const item_key = discount_allocation?.key.replace(/-/g, "");
        const dis_value = `-${discount_allocation?.value}`;

        if (discount_allocation) {
          const item_variant_id = cart_item?.variant_id || "";

          _gs_discount_application[item_variant_id] = {
            eligible_bxyg_quantity: "",
            line_item_id: item_variant_id,
            line_item_key: `${item_variant_id}:${ item_key || ""}`,
            target_selection: discount_allocation?.target_selection || "entitled",
            target_type: discount_allocation?.target_type || "",
            title: discount_allocation?.title || "",
            total_allocated_amount: discount_allocation?.total_allocated_amount/100 || "",
            type: discount_allocation?.type || "",
            value:  dis_value || "",
            value_type: discount_allocation?.value_type || ""
          };

          localStorage.setItem(item_variant_id, JSON.stringify(_gs_discount_application[item_variant_id]));
        }
      }
    }

    return null;
  } catch (error) {
    console.error("Error fetching or processing cart data:", error);
    return null;
  }
}

function removeOhnutsDiscountInfo(){
  localStorage.removeItem("couponCode");
  localStorage.removeItem("freeShipping");
  localStorage.removeItem("discountNode");
  localStorage.clear();
}

async function getFestiveData() {
  const container = document.getElementById("festive-options-container");
  container.innerHTML = "";

  try {
    const url = `${SHOPIFY_APP_BASE_URL}/get-festive-settings`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(url, options);
    const responseJson = await response.json();

    giftMessageCharactersThresholdValue = (
      responseJson?.custom?.app_settings?.giftMessageCharactersThreshold
      || DEFAULT_GIFT_MESSAGE_CHARACTERS_THRESHOLD
    );

    giftMessageLinesThresholdValue = (
      responseJson?.custom?.app_settings?.giftMessageLinesThreshold
      || DEFAULT_GIFT_MESSAGE_LINES_THRESHOLD
    );

    document.querySelector("#giftMessage").setAttribute(
      "maxlength",
      giftMessageCharactersThresholdValue
    );

    setGiftMessageWarnings(
      giftMessageCharactersThresholdValue,
      giftMessageLinesThresholdValue
    );

    const festiveData = responseJson?.data || [];
    if (!Array.isArray(festiveData) || festiveData.length === 0) {
      return;
    }

    festiveData.forEach(festive => {
      let festiveDiv = document.createElement("div");
      festiveDiv.classList.add("fastivle-div");
      let radioInput = document.createElement("input");
      radioInput.type = "radio";
      radioInput.classList.add("radio","festive");
      radioInput.id = festive.id;
      radioInput.name = "date-type";
      radioInput.value = festive.id;
      let messageLabel = document.createElement("label");
      messageLabel.htmlFor = festive.id;
      messageLabel.classList.add("festive-message");
      if (festive.messageHeading) {
        messageLabel.innerHTML += `<p>${festive?.messageHeading}</p>`;
      } else {
        messageLabel.innerHTML += `<h4>${festive?.festiveName}</h4>`;
      }

      // if (festive.messageSubHeading) {
      //   messageLabel.innerHTML += `<span>${festive?.messageSubHeading}</span>`;
      // }

      festiveDiv.appendChild(radioInput);
      festiveDiv.appendChild(messageLabel);
      container.appendChild(festiveDiv);
    });
  } catch (error) {
    console.error("Error fetching festive settings:", error);
  } finally {
    checkingchosenShippingMethod();
  }
}

function checkingchosenShippingMethod(){
  const selectedShippingMethod = document.querySelector('[name="customer-shipping"]:checked');
  if (selectedShippingMethod) {
    const shippingMethodDetailsEle = document.querySelector(`#${selectedShippingMethod.id}-details`);
    let chosenShippingMethod = "";
    if (shippingMethodDetailsEle) {
      chosenShippingMethod = JSON.parse(shippingMethodDetailsEle?.innerHTML);
      const ShippingMethodtitle = chosenShippingMethod?.title;
      if (
        ShippingMethodtitle
        && !SHIPPING_METHODS_REQUIRED_DELIVERY_DATE.includes(ShippingMethodtitle)
      ) {
        const deliveryDateInputGroupSelector = `#delivery-date-container`;
        document.getElementById("delivery-date").value = "";
        return addClassesToElements(deliveryDateInputGroupSelector, ["read-only"]);
      }
    }
  }
}

document.getElementById("delivery-date").addEventListener("change", function() {
  document.getElementsByName("date-type").checked = false;
  document.getElementById("delivery").checked = true;
});

document.addEventListener("click", function (event) {
  const target = event.target;
  if (target.classList.contains("festive") && target.type === "radio") {
    document.getElementById("delivery-date").value = "";
    setDeliveryDatesForAddreses();
  }
});

function daleverySectionValidation(ShippingMethodtitle) {
  if (
    ShippingMethodtitle
    && !SHIPPING_METHODS_REQUIRED_DELIVERY_DATE.includes(ShippingMethodtitle)
  ) {
    document.getElementsByName("date-type").checked = false;
    document.getElementById("delivery").checked = true;
    document.getElementById("delivery-date").value = "";
  }
}
